import { useRef } from "react";
import PropTypes from "prop-types";
import { t } from "@/i18n-js/instance";
import { Icon } from "@circle-react-shared/Icon";
import { Tippy } from "@circle-react-shared/Tippy";
import { Button } from "@circle-react-uikit/Button";
import { Typography } from "@circle-react-uikit/Typography";

export const Header = ({ files, isUploading, handleUpload, meta }) => {
  const inputRef = useRef(null);

  return (
    <div className="flex items-center justify-between pb-4 pt-5">
      <span>
        <Typography.LabelMd weight="semibold">
          {t("courses.edit.lesson.tabs.files.files_count", {
            count: files.length,
          })}
        </Typography.LabelMd>
        <Tippy
          content={t("courses.edit.lesson.tabs.files.max_files_count", {
            count: meta.max_files_count,
          })}
          placement="top"
        >
          <Icon type="question-mark" className="icon--xs text-dark ml-2" />
        </Tippy>
      </span>
      <input
        ref={inputRef}
        type="file"
        onChange={handleUpload}
        style={{ display: "none" }}
      />
      <Button
        variant="secondary"
        type="button"
        small
        className="!rounded-md !px-2.5 !py-0.5 text-xs font-medium"
        onClick={() => inputRef.current.click()}
        disabled={isUploading || !meta.policies?.can_add_files}
      >
        {t(
          `courses.edit.lesson.tabs.files.${
            isUploading ? "uploading" : "add_file"
          }`,
        )}
      </Button>
    </div>
  );
};

Header.propTypes = {
  files: PropTypes.arrayOf(PropTypes.object).isRequired,
  isUploading: PropTypes.bool.isRequired,
  handleUpload: PropTypes.func.isRequired,
  meta: PropTypes.shape({
    max_files_count: PropTypes.number.isRequired,
    policies: PropTypes.shape({
      can_add_files: PropTypes.bool.isRequired,
    }).isRequired,
  }).isRequired,
};
